"use client";

import { Link } from "@/components/common/Link";
import { Checkbox } from "@/components/ui/checkbox";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Instagram, Linkedin } from "lucide-react";
function FooterNavConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-3 w-20 bg-muted/40 animate-pulse" />
        <div className="h-3 w-24 bg-muted/40 animate-pulse" />
        <div className="h-3 w-16 bg-muted/40 animate-pulse" />
      </div>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="text-foreground font-default uppercase text-[12px] tracking-[0.15em] relative inline-block group">
            <span className="relative">
              {item.label}
              <span className="absolute left-0 -bottom-0.5 h-px w-0 bg-primary transition-all duration-300 group-hover:w-full" />
            </span>
          </Link>
        </li>)}
    </ul>;
}
const expertiseItems = ["Social Media", "Content Creatie", "Influencer Marketing", "Video Productie", "Strategie"];
const socialItems = [{
  label: "LinkedIn",
  href: "https://linkedin.com",
  icon: "Linkedin",
  link: {
    href: "https://www.linkedin.com/company/socialcomplex/posts/?feedView=all",
    newTab: true
  }
}, {
  label: "TikTok",
  href: "https://tiktok.com",
  icon: "TikTok",
  link: {
    href: "https://www.tiktok.com/@socialcomplex",
    newTab: true
  }
}, {
  label: "Instagram",
  href: "https://instagram.com",
  icon: "Instagram",
  link: {
    href: "https://www.instagram.com/socialcomplex.nl/",
    newTab: true
  }
}];
const bottomLinks = [{
  label: "Algemene Voorwaarden",
  href: "https://outgoing-horse.10web.cloud/wp-content/uploads/2026/07/Algemene-Voorwaarden-site.pdf",
  link: {
    href: "https://outgoing-horse.10web.cloud/wp-content/uploads/2026/07/Algemene-Voorwaarden-site.pdf",
    newTab: true
  }
}, {
  label: "Privacybeleid",
  href: "/Privacybeleid",
  link: {
    href: "https://socialcomplex.nl/wp-content/uploads/2026/08/SocialComplex_Privacyverklaring.pdf",
    newTab: true
  }
}];
export default function Footer() {
  return <section data-section-id="3691" id="premiumdarkfooter" className="relative bg-background text-foreground pt-[120px] pb-12 overflow-hidden">
      {}
      

      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {}
        <div className="mb-16 md:mb-24">
          <h2 className="font-default font-extrabold text-foreground leading-[0.85] tracking-[-0.05em] select-none" style={{
          fontSize: "clamp(4rem, 14vw, 14rem)"
        }}>
            <Link to="/">
              <WvcLogo className="h-[0.8em] w-auto" />
            </Link>
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          {}
          <div className="flex flex-col gap-5">
            
            <div className="font-default text-base leading-relaxed text-foreground/90">Kremerskamp 26<br />7261TH Ruurlo<br />Nederland</div>
            
          </div>

          {}
          

          {}
          

          {}
          <div className="flex flex-col gap-5">
            
            <Link to="mailto:hello@socialcomplex.nl" className="font-default italic text-base text-foreground hover:text-primary transition-colors duration-300">info@socialcomplex.nl</Link>
            <Link to="tel:+31201234567" className="font-default text-sm text-foreground/90 hover:text-primary transition-colors duration-300 tracking-wider">+31 24814520</Link>
            <div className="flex items-center gap-4 mt-2">
              {socialItems.map((social, i) => <Link className="rounded-full w-10 h-10 flex items-center justify-center border border-foreground/20 text-foreground/90 hover:text-primary hover:border-primary transition-colors duration-300 underline cursor-pointer" {...social.link}><Link key={social.label} data-index={i} to={social.href} newTab aria-label={social.label}>
                  {social.icon === "Linkedin" && <Link className="size-5 underline cursor-pointer" {...social.link}><Linkedin /></Link>}
                  {social.icon === "Instagram" && <Link className="size-5 underline cursor-pointer" {...social.link}><Instagram /></Link>}
                  {social.icon === "TikTok" && <Link className="size-5 underline cursor-pointer" {...social.link}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
                    </svg></Link>}
                </Link></Link>)}
            </div>
          </div>
        </div>

        {}
        

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
          {}
          <div className="font-default uppercase text-[10px] tracking-[0.2em] text-muted-foreground text-center md:text-left">© &nbsp;SOCIALCOMPLEX · ALLE RECHTEN VOORBEHOUDEN</div>

          {}
          

          {}
          <div className="flex items-center justify-center md:justify-end gap-4">
            {bottomLinks.map((link, i) => <div key={link.label} data-index={i} className="flex items-center gap-2">
              
              <Link className="font-default uppercase text-[10px] tracking-[0.2em] text-muted-foreground hover:text-primary transition-colors duration-300 underline cursor-pointer underline cursor-pointer" {...link.link}><Link {...link.link}><Link to={link.href}>
                {link.label}
              </Link></Link></Link>
            </div>)}
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-[4px] bg-primary" />
    </section>;
}